import React, { useState } from 'react';
import { makeStyles, Theme, createStyles, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Avatar, IconButton } from '@material-ui/core';
import { OpenInNew as OpenInNewIcon } from "@material-ui/icons"
import { SpriteDefine } from '../../../../Character/SpriteManager'
import CharDialog from '../../../../Character/CharDialog';
import { useTranslation } from "react-i18next"

import  * as Lambda from "../../../../../Lambda";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2)
    },
    table: {
      minWidth: 650,
    },
  }),
);

interface Props {
  room: Lambda.RoomType | undefined
  sprite?: SpriteDefine | undefined
}

function TableView(props: Props) {

  const classes = useStyles()
  const [t] = useTranslation()

  const [popup, setPopup] = useState<Lambda.MemberType | undefined>()

  return (
    <div className={classes.root}>

      <TableContainer component={Paper}>
        <Table stickyHeader  className={classes.table} size="small" >
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>{t("label.character.handle")}</TableCell>
              <TableCell></TableCell>
              <TableCell>{t("label.character.status")}</TableCell>
              <TableCell>{t("label.character.busyness")}</TableCell>
              <TableCell>{t("label.character.comment")}</TableCell>
              {
                props?.room?.fields?.map(field=>(
                  <TableCell>{field.label}</TableCell>
                ))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {props.room?.members?.map((member) => member.join ? (
              <TableRow key={member.id}>
                <TableCell><Avatar src={member?.icon?.get}>{member.name.slice(0, 1)}</Avatar></TableCell>
                <TableCell>{member.name}</TableCell>
                <TableCell><IconButton onClick={()=>member.join && setPopup(member)}><OpenInNewIcon /></IconButton></TableCell>
                <TableCell>{t(`status.${member.status}`)}</TableCell>
                <TableCell>{member.busyness}</TableCell>
                <TableCell>{member.comment}</TableCell>
                {
                  props?.room?.fields?.map(field=>(
                    <TableCell>{member.attributes[field.id]}</TableCell>
                  ))
                }
              </TableRow>
            ) : null)}
          </TableBody>
        </Table>
      </TableContainer>
      <CharDialog 
          sprite={props.sprite} 
          member={popup} 
          open={popup !== undefined} 
          onClose={()=>setPopup(undefined)}
          />
    </div>
  )
}

export default TableView;